/*
 * Number of per-speaker color slots. Speakers are assigned a slot via
 * `index % SPEAKER_COLOR_COUNT`; the actual colors live as themed CSS classes
 * (`speaker-{bg,light-bg,text,hover-bg}-<slot>`) in
 * apps/content-studio/src/speaker-colors.css.
 */
export const SPEAKER_COLOR_COUNT = 8;

export const screenShareBarsColors = {
  bgColor: 'bg-slate-600',
  lightBgColor: 'bg-slate-100',
  textColor: 'text-slate-600',
  hoverBgColor: 'hover:bg-slate-300'
};

export const sharedVideoBarsColors = {
  bgColor: 'bg-blue-900',
  lightBgColor: 'bg-blue-100',
  textColor: 'text-blue-900',
  hoverBgColor: 'hover:bg-blue-800'
};
